import {TooltipState, Tooltip} from './tooltip';

export class ValidationTooltip extends Tooltip {
	public override readonly state = new TooltipState();
	private hideTimeout: number;


	tooltipTimeout: number;
	tooltip: boolean = false;


	override componentDidMount(): void {
		super.componentDidMount();
		if (this.element) {
			this.initTooltip(this.element);
		}
	}

	initTooltip(element: HTMLElement) {
		if (this.props.notHide) {
			this.showTooltip(false);
			return;
		}

		element.addEventListener('mouseover', () => {
			if (this.rootElement) {
				this.showTooltip(false);
			}
		});

		element.addEventListener('mouseout', () => {
			if (this.rootElement) {
				this.hideTooltip();
			}
		});
	}


	override componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{}>, prevContext: any): void {
		if (prevProps.show !== this.props.show || prevProps.children !== this.props.children) {
			this.showTooltip();
		}
	}

	override showTooltip(hide: boolean = true) {
		super.showTooltip();

		clearTimeout(this.hideTimeout);
		if (hide) {
			this.hideTimeout = window.setTimeout(() => {
				this.hideTooltip();
			}, 2000);
		}
	}

	protected override hideTooltip() {
		super.hideTooltip();
		clearTimeout(this.hideTimeout);
	}
}